import {Text} from 'quickstart/components/content/Text'
import {Box} from 'quickstart/components/layout/Box'
import {Item, Stack} from 'quickstart/components/layout/Stack/styles'
import styled, {
  SystemProps,
  css,
  system,
  th,
} from 'quickstart/styled-components/system'

const Sectional = styled(Box).attrs({as: 'section'})``

export const Section = styled(Sectional)<
  SystemProps & {
    variant?: 'default' | 'skinny' | 'superskinny' | 'abutting'
  }
>(
  ({variant}) => css`
    ${th(`sections.${variant || 'default'}`)};
    ${system};
  `,
)

const Heading = styled(Text).attrs(props => ({
  prose: true,
  variant: 'sectionHead',
  ...props,
}))``

export const SectionHeading = styled(Heading)<SystemProps>`
  :is(${Stack}, ${Item}) > & {
    margin-bottom: 0;
  }
  ${system}
`
